/**
 * 뮤직비디오 그리드 한 칸 — BEM video-grid__* 와 동일 구조로 DOM 생성.
 */
export interface MusicVideoItemData {
    id: number;
    title: string;
    thumb: string | null;
    href: string;
    /** YouTube video id (11 chars) when source is YouTube */
    youtubeId?: string | null;
}

export class MusicVideoItem {
    static createLi(item: MusicVideoItemData): HTMLLIElement {
        const li = document.createElement("li");
        li.className = "video-grid__item";

        const a = document.createElement("a");
        a.className = "video-grid__link";
        a.href = item.href;

        const media = document.createElement("span");
        media.className = "video-grid__media";

        if (item.thumb) {
            const img = document.createElement("img");
            img.className = "video-grid__thumb";
            img.src = item.thumb;
            img.alt = item.title;
            img.loading = "lazy";
            img.decoding = "async";
            media.appendChild(img);
        } else {
            const ph = document.createElement("span");
            ph.className = "video-grid__thumb video-grid__thumb--placeholder";
            ph.setAttribute("aria-hidden", "true");
            media.appendChild(ph);
        }

        const overlay = document.createElement("span");
        overlay.className = "video-grid__overlay";
        overlay.setAttribute("aria-hidden", "true");

        const dim = document.createElement("span");
        dim.className = "video-grid__dim";

        const frame = document.createElement("span");
        frame.className = "video-grid__frame";
        for (const pos of ["tl", "tr", "bl", "br"] as const) {
            const corner = document.createElement("span");
            corner.className = `video-grid__frame-corner video-grid__frame-corner--${pos}`;
            frame.appendChild(corner);
        }

        const content = document.createElement("span");
        content.className = "video-grid__content";
        const titleEl = document.createElement("span");
        titleEl.className = "video-grid__title";
        titleEl.textContent = item.title;
        content.appendChild(titleEl);

        overlay.append(dim, frame, content);
        media.appendChild(overlay);
        a.appendChild(media);
        li.appendChild(a);

        return li;
    }
}
